import {create} from 'zustand'


export const useProductosCarrito = create((set, get) => ({
    productos: [],
    agregarProducto: (prod) => set((state) => sumarProducto(state.productos, prod)),
    quitarProducto: (prod) => set((state) => restarProducto(state.productos, prod)),
    limpiarProductos: () => set({productos: []}),
    estaProducto: (prod) => get((state) => verificarProducto(state.productos, prod)),
    obtenerProducto: (id) => obtenerProducto(get().productos, id),
}))


const obtenerProducto = (productos, id) => {

    let index = productos.findIndex(producto => producto.id === id)
    if (index >= 0) {
        return productos[index]
    } else {
        return null
    }
}

const sumarProducto = (prodsArr, prod) => {

    //Verificamos si el producto esta en productos
    let encontrado = false
    for (let i = 0; i < prodsArr.length; i++) {
        if (prodsArr[i].id === prod.id) {
            let prodEncontrado = prodsArr[i]
            prodEncontrado.cantidad = prodEncontrado.cantidad + 1
            encontrado = true
        }
    }

    if (!encontrado) {
        prod.cantidad = 1
        prodsArr.push(prod)
    }

    return (
        {productos: prodsArr}
    )

}

const restarProducto = (prodsArr, prod) => {

    //Verificamos si el producto esta en productos

    for (let i = 0; i < prodsArr.length; i++) {
        if (prodsArr[i].id === prod.id) {
            let prodEncontrado = prodsArr[i]
            prodEncontrado.cantidad = prodEncontrado.cantidad - 1
            if (prodEncontrado.cantidad <= 0) {
                prodsArr.splice(i, 1)
            }
        }
    }


    return (
        {productos: prodsArr}
    )

}

const verificarProducto = (prodsArr, prod) => {


    console.log('verificando')

    for (let i = 0; i < prodsArr.length; i++) {
        if (prodsArr[i].id === prod.id) {
            return true
        }
    }


    return false

}



